module.exports = __webpack_public_path__ + "static/media/1POLICY33.7633a719.jpg";